import type { ReactElement } from 'react';

import { Card, Flex } from '@rango-dev/whale';
import React from 'react';
import { useParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../../hooks/reduxHooks';
import {
  dispatchCancellableAction,
  fetchProfileSummary,
  showPrivateProfileSelector,
} from '../../../state/ProfileSlice';
import { profileSummarySelector } from '../../../state/ProfileSlice/selectors';
import { ProfileCard } from '../ProfileCard';
import { ProfileFavorites } from '../ProfileFavorites';
import { ProfileSummaryItems } from '../ProfileSummaryItems';
import { UnexpectedError } from '../UnexpectedError';

export function ProfileSummaryMobile(): ReactElement {
  const params = useParams<{ username: string }>();
  const { error } = useAppSelector((state) => profileSummarySelector(state, params.username));
  const showPrivateProfile = useAppSelector((state) =>
    showPrivateProfileSelector(state, params.username),
  );
  const dispatch = useAppDispatch();

  const refetchProfileSummary = () => {
    if (params.username) {
      dispatchCancellableAction(dispatch, fetchProfileSummary, {
        username: params.username,
        public: !showPrivateProfile,
      });
    }
  };

  return (
    <Flex direction="column" gap="2">
      <ProfileCard />
      {error ? (
        <Card variant="surface" size="3">
          <UnexpectedError
            context="profile-page-profile-summary-mobile"
            onRetry={refetchProfileSummary}
          />
        </Card>
      ) : (
        <Card variant="surface" size={{ initial: '1', sm: '3' }}>
          <Flex direction="column" gap="4">
            <ProfileSummaryItems />
            <ProfileFavorites />
          </Flex>
        </Card>
      )}
    </Flex>
  );
}
